<template>
  <div id="priceAdjustmentRecordsList" style="width: 100%;height: 100%">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" size="medium"
        style="padding-top: 0; margin-top: 0;">
        <el-col>
          <el-form-item label="团餐公司：">
            <el-select v-model="searchForm.TC_ID" filterable placeholder="请选择" clearable>
              <el-option v-for="item in tcList" :key="item.TC_ID" :label="item.AB_NAME" :value="item.TC_ID">
                <span style="float: left">{{ item.AB_NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select filterable v-model="searchForm.PROJECT_ID" @change="__querydkList()" placeholder="请选择" clearable>
              <el-option v-for="item in projectList" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID">
                <!-- <span style="float: left">{{ item.PROJECT_NAME }}</span> -->
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单日期：">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="审核状态：">
            <el-select filterable v-model="searchForm.ADJUST_STATUS" placeholder="请选择" @change="handleSearch">
              <el-option v-for="item in adjustStatusList" :key="item.value" :label="item.NAME"
                :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button id="search" type="primary" @click="handleSearch" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" width="50" min-width="30" label="序号"></el-table-column>
          <el-table-column prop="TC_NAME" label="团餐公司" min-width="90"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="95"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
          <el-table-column fixed="right" label="操作" width="70">
            <template slot-scope="scope">
              <el-button type="text" size="small"  @click="detail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {
        ADJUST_STATUS: 1,
      },
      tcList: JSON.parse(sessionStorage.getItem('allCustomerList')) || [],
      projectList: JSON.parse(sessionStorage.getItem('usingProjectList')) || [],
      adjustStatusList: [
        {
          NAME: '未审核',
          ID: 1,
        },
        {
          NAME: '审核通过',
          ID: 2,
        },
        {
          NAME: '审核拒绝',
          ID: 3,
        },
      ],
      tableData: [],
      loadSearch: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION.CONDITION) {
      this.searchForm = this.PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION.CONDITION;
      this.currentPage = this.PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData(this.currentPage - 1);
  },
  computed: {
    PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION() {
      return this.$store.state.PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION;
    },
  },
  methods: {
    // ---------------------------------------------------点击筛选按钮触发
    handleSearch() {
      this.currentPage = 1;
      this.queryData(0);
    },
    queryData(PAGE_INDEX) {
      let params = {
        SERVICE_ID: '10260',
        OTYPE: 3,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_INDEX,
        PAGE_SIZE: this.pageSize,
      };
      if (JSON.stringify(this.searchForm) != '{}') {
        params = {
          ...params,
          ...this.searchForm,
        };
        if (params.DAY_INTERVAL && params.DAY_INTERVAL[0]) {
          [params.START_DAY, params.END_DAY] = params.DAY_INTERVAL;
        }
        delete params.DAY_INTERVAL;
      }
      this.loadSearch = true;
      http.post(params).then((res) => {
        if (res[0]) {
          this.totalCount = res[0].TOTAL_COUNT;
          this.tableData = res[0].LIST;

          this.$store.dispatch('SET_PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
        this.loadSearch = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.loadSearch = false;
      });
    },
    // ------------------------------------查看
    detail(row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('adjustStatus', this.searchForm.ADJUST_STATUS);
      this.$router.push({ path: '/priceAdjustmentDetail/detail' });
    },
    handleCurrentChange() {
      this.queryData(this.currentPage - 1);
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/priceAdjustmentRecordsList.vue